import { useQuery } from '@tanstack/react-query'
import { PayRateMetrics, getPayRateMetrics } from 'api/pulse/payRateMetrics'
import { PulseFilters } from 'api/pulse'
import { getPayRateMetricsKey } from './keys'
import { PULSE_QUERY_OPTIONS } from './constants'

export function usePayRateMetrics(query: PulseFilters) {
  return useQuery<PayRateMetrics>({
    ...PULSE_QUERY_OPTIONS,
    queryKey: getPayRateMetricsKey(query),
    queryFn: ({ signal }) => getPayRateMetrics(query, signal),
    enabled: !!query.companyIds?.length,
  })
}
